"use client"

import Link from "next/link"
import { RefreshCw } from "lucide-react"

import { getPopularCategoryClassName } from "@/components/home/popular-products"
import { getBrandCategories, getBrandsHref } from "@/lib/brand-categories"

export default function BrandCategoryFilters({
  categories,
  selectedIndex,
}: {
  categories?: string[]
  selectedIndex?: number
}) {
  const filters = [
    { name: "Trending", index: undefined },
    ...getBrandCategories(categories ?? []),
  ]

  return (
    <>
      <nav aria-label="Brand categories" className="mt-6 flex flex-wrap gap-2">
        {filters.map((category) => (
          <Link
            key={category.index ?? "trending"}
            href={getBrandsHref(1, category.index)}
            prefetch={false}
            aria-current={selectedIndex === category.index ? "page" : undefined}
            aria-controls="brand-stores-results"
            className={getPopularCategoryClassName(
              selectedIndex === category.index
            )}
          >
            {category.name}
          </Link>
        ))}
      </nav>
      {categories === undefined && (
        <div
          role="alert"
          className="mt-3 flex items-center gap-3 text-[14px] text-[#4E5969]"
        >
          Categories could not be loaded.
          <button
            type="button"
            className="inline-flex items-center gap-1 text-[#0F9E4F]"
            onClick={() => window.location.reload()}
          >
            <RefreshCw size={14} aria-hidden="true" /> Retry
          </button>
        </div>
      )}
    </>
  )
}

export function BrandCategoryFiltersSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading brand categories"
      className="mt-6 flex flex-wrap gap-2"
    >
      {[80, 108, 120, 148].map((width) => (
        <span
          key={width}
          aria-hidden="true"
          style={{ width }}
          className="h-[30px] rounded-[6px] bg-white motion-safe:animate-pulse"
        />
      ))}
    </div>
  )
}
